"use client";

import { IComponent } from "@faire/web-api/indigofair/data/IComponent";
import React from "react";

import { SDUIComponentRenderer } from "../../__internal__/SDUIComponentRenderer/SDUIComponentRenderer";
import {
  SDUISectionInstanceRendererProps,
  SectionLoggingEventParams,
} from "../../__internal__/types";

import {
  animatedInContainer,
  animatedOutContainer,
  componentGridContainer,
} from "./styles/SDUIRotatingSectionRenderer.css";
import { useAnimatedRotation } from "./useAnimatedRotation";

export const SDUIRotatingSectionComponentRenderer: React.FC<
  SDUISectionInstanceRendererProps
> = ({ section, componentRenderers, loadTimingRef }) => {
  const { components, delay: rotationDelayMs } = section.rotating_section ?? {};

  const { resumeScroll, pauseScroll, isVisible, currentIndex } =
    useAnimatedRotation(components, rotationDelayMs);

  if (!components || !components[currentIndex]) {
    return null;
  }

  return (
    <div
      className={componentGridContainer}
      onMouseEnter={pauseScroll}
      onMouseLeave={resumeScroll}
    >
      <div
        style={{
          height: "100%",
          display: "flex",
          alignItems: "center",
        }}
        className={isVisible ? animatedInContainer : animatedOutContainer}
      >
        <SDUIComponentRenderer
          isPrimaryContent
          component={components[currentIndex] ?? IComponent.build({})}
          componentRenderers={componentRenderers}
          sectionLoggingParams={SectionLoggingEventParams.build()}
          loadTimingRef={loadTimingRef}
        />
      </div>
    </div>
  );
};
